import { useLocalStorageValue as d, useSessionStorageValue as f } from "@react-hookz/web";
import { useCallback as o, useMemo as V } from "react";
const R = (t, a) => {
  const {
    fetch: s,
    remove: l,
    set: c,
    value: e
  } = d(t, a), {
    fetch: r,
    remove: n,
    set: u,
    value: S
  } = f(t, a), h = o((g) => {
    try {
      c(g);
    } catch {
      u(g);
    }
  }, [c, u]), m = o(() => {
    s(), r();
  }, [s, r]), v = o(() => {
    l(), n();
  }, [l, n]), i = V(() => e ?? S, [e, S]);
  return {
    fetch: m,
    remove: v,
    set: h,
    value: i
  };
};
export {
  R as u
};
//# sourceMappingURL=fallback-storage-value-z-Nu1MMs.mjs.map
